

<template>
  <div class="goalList">
    <el-card class="box-card mb20">
      <div class="tit">{{title}}</div>
      <div>
        <el-table
          :data="tabledata"
          style="width: 100%"
          :default-sort="defaultSort"
          @sort-change="sortChange"
          class="panel-top-table"
        >
          <el-table-column
            v-for="(item,index) in columns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :header-align="item.headeralign"
            :align="item.align"
            :min-width="item.minwidth"
            :sortable="item.sortable"
            :sort-orders="['ascending', 'descending']"
            :show-overflow-tooltip="item.tooltip == false ? false : true"
          >
            <template slot-scope="scope">
              <span v-if="item.filter=='toThousands'">
                 <!-- <div  class="nowarp" v-if="item.prop=='cost'&& (ordertit=='1' || ordertit=='3' )">¥{{ scope.row[item.prop]|toThousands }}</div>
                  -->
                  <div  class="nowarp" v-if="item.prop=='cost'">{{ scope.row[item.prop]|toThousands }}</div>
                  <div class="nowarp"  v-else >{{scope.row[item.prop]|toThousands }}</div>
                </span>

              <span v-else>
                <div v-if="item.prop=='date_nums'">
                  <span
                    :class="scope.row['date_nums_color']=='1' ? 'redColor':''"
                  >{{scope.row['date_nums']}}</span>
                </div>
                <!--<div v-else-if="item.prop=='company_name' || item.prop=='app_name'">-->
                 <!--<el-tooltip :content="scope.row[item.prop]" placement="top">-->
                      <!--<span>{{scope.row[item.prop]}}</span>-->
                         <!--&lt;!&ndash; <span >{{scope.row[item.prop].length>11?scope.row[item.prop].slice(0,11)+'...' :scope.row[item.prop]}}</span> &ndash;&gt;-->
                  <!--</el-tooltip>-->
                 <!---->
                 <!---->
                <!--</div>-->
                <div class="ellipsis pl4" v-else>{{scope.row[item.prop]}}</div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "goalList",
  props: {
    title: {
      type: String,
      defult: ""
    },
    ordertit: {
      type: String,
      defult: ""
    },
    tabledata: {
      type: Array,
      require: true,
      defult: []
    },
    columns: {
      type: Array,
      require: true,
      defult: []
    },
    defaultSort: {
      type: Object,
      require: true,
      defult: {
        prop: "",
        order: ""
      }
    }
  },
  data() {
    return {};
  },
  filters: {
    toThousands(num) {
      return Number(num)
        .toFixed(2)
        .toString()
        .replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
    }
  },
  created() {},
  computed: {},

  methods: {
    sortChange(val) {
      this.$emit("order", val, this.ordertit);
      console.log("==val==", val);
    },
  }
};
</script>
<style lang="scss" scoped>
.goalList {
  ::v-deep .el-table th.el-table__cell > .cell {
    padding-left: 0px;
    padding-right: 0px;
  }
  ::v-deep .el-table .cell {
    padding-left: 0px;
    padding-right: 0px;
  }

  ::v-deep .el-table td.el-table__cell,
  ::v-deep .el-table th.el-table__cell.is-leaf {
    border: none;
      padding: 2px 0;
  }
  ::v-deep .el-table--border::after,
  ::v-deep.el-table::before{
    background-color: transparent;
}


::v-deep .el-table__fixed::before {
  width: 0;
}

    ::v-deep.panel-top-table .caret-wrapper{
        pointer-events: none;
    }

  .nowarp {
    white-space: nowrap;
    overflow: hidden;
    // text-overflow: ellipsis;
  }


  .tit {
    font-size: 14px;
    text-align: left;
    font-weight: 650;
    color: #000000;
  }
  .redColor {
    color: red;
  }
}
</style>
